import { ReactNode } from 'react'

export const enum ATTACHMENT_TYPE {
  Text = 'TEXT',
  Image = 'IMAGE',
  Audio = 'AUDIO',
}

export interface Tabs {
  title: string
  children: ReactNode
}
interface Content {
  text: string
}
export interface Attachments {
  audios: string[]
  images: string[]
  videos: string[]
  attached_images: string[]
  video_links: string[]
}

interface UserProfile {
  block: string | null
  district: string | null
  state: string | null
}
interface User {
  full_name: string
  photo_S3_path: string | null
  profile?: UserProfile
  is_verified: boolean
}

interface GenericPost {
  id: number
  user: User
  is_liked: boolean
  view_count: number
  like_count: number
  comment_count: number
  pinned: boolean
  created_at: string
  updated_at: string
  slug: string
  tags: number[]
  language: string
}
export interface DehaatPosts extends GenericPost {
  attachments: Attachments
  content: string
  name: string
}

export interface CommunityPost extends GenericPost {
  attachments: Attachments
  content: Content
  type: string
  display_comment: Comment | null
}

export interface Comment {
  content: Content
  created_at: string
  user: User
  id: number
  attachments: Attachments | null
  type: string
}

export interface BlogComment {
  content: string
  created_at: string
  user: User
  id: number
  attachments: Attachments | null
  type: string
}
